import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('appointment-form', 'inspect-patient');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: ['form_inspections'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/inspect-patient-form.js